import { cn } from '@/lib/utils'

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)

/** A keyboard key, with ⌘ / Ctrl resolved for the platform. Hidden on touch screens. */
export function Kbd({ keys, className }: { keys: string | string[]; className?: string }) {
  const list = (Array.isArray(keys) ? keys : [keys]).map((key) =>
    key === 'mod' ? (IS_MAC ? '⌘' : 'Ctrl') : key,
  )
  return (
    <span className={cn('hidden items-center gap-0.5 [@media(hover:hover)]:inline-flex', className)} aria-hidden="true">
      {list.map((key, index) => (
        <kbd key={index} className="kbd">
          {key}
        </kbd>
      ))}
    </span>
  )
}

export const isMac = IS_MAC
